function Home() {
  return <div style={{height: 700}}></div>;
}
export default Home;
